export enum Experiment {
  EnableSectionsTabInMobileAS = 'specs.membersAboutOOI.enableSectionsMobileAS',
  EnableOOIInEditor = 'specs.membersArea.framelessEditorProfilePage',
  EnableCSSOptimization = 'specs.membersAboutOOI.EnableCSSOptimization',
  AboutPublishValidation = 'specs.about.MembersAboutSpecs$ValidateLinksInAboutContent',
  BlogLiveSiteEditingDeprecation = 'specs.wixBlog.LiveSiteEditorDeprication',
  EnableMobileDesignTabSectionHeaders = 'specs.membersAboutOOI.EnableMobileDesignTabSectionHeaders',
  EnableButtonBorderSettings = 'specs.membersAboutOOI.EnableButtonBorderSettings',
  EnableMobileTitleSetting = 'specs.membersAboutOOI.EnableMobileTitleSetting',
  DisableButtonOnPublish = 'specs.membersAboutOOI.DisableButtonOnPublish',
  EnablePluralStatisticFix = 'specs.membersAboutOOI.EnablePluralStatisticFix',
  EnablePostListInSEO = 'specs.membersAbout.EnablePostListInSEO',
  EnableRicosContentInSEO = 'specs.membersAbout.EnableRicosContentInSEO',
  EnableWDSPanels = 'specs.membersAbout.EnableWDSPanels',
  EnableCSSIndicators = 'specs.membersAbout.EnableCSSIndicators',
  RenderBlogContributorSEOTags = 'specs.membersAbout.renderBlogContributorSEOTags',
}
